import { IDocumentType } from "store/lobby/lobby-model";

export interface ILocationData {
  id: number;
  description: string;
}

export interface IProcessData {
  id: number;
  description: string;
  active?: boolean;
  vehicleSteps?: number[];
}

export interface IStructureData {
  id: number;
  description: string;
  level: number;
  parentId: number;
  childrens: IStructureData[];
}

export interface IStructuresAllData {
  id: number;
  description: string;
}

export interface IlocationByStructureId {
  id: number;
  description: string;
}

export interface ILocationFilter {
  orderBy: string;
  ascend: string;
  itemsByPage: number;
  pageIndex: number;
}

export interface ILocationActiveData {
  id: number;
  description: string;
}

export type IItems = {
  id: number;
  code: string;
  description: string;
  structure: string;
  active: boolean;
};

export interface ILocation {
  active: boolean;
  addressState?: string;
  city?: string;
  code?: string;
  companyDocument?: string;
  country?: string;
  description: string;
  id: number;
  processes: Array<IProcessData>;
  structureId: number;
  geo: number;
  hasCheckin: boolean;
  hasAttendance: boolean;
  checkinExpirationTime: number;
  allowRequestVehicleInboundAction: boolean;
  allowRequestDockEntryAction: boolean;
  hasFinishOperationAction: boolean;
  allowRequestVehicleEntryAuthorizationAction: boolean;
  allowVehicleArrivalConfirmAction: boolean;
  hasReleaseWMSDocuments: boolean;
  hasLocationOutOfRange: boolean;
  hasCheckinSchedule: boolean;
  documentType: IDocumentType;
  dropHookTypeOfYard: number;
  hasEntryPermission: boolean;
  hasRfidReading: boolean;
  plateFormatType: number;
}

export interface IConfigurationActive {
  id: number;
  description: string;
  configuration: boolean;
  descriptionName: string;
  configurationName: string;
  isCheckinTime: boolean;
  expirationTime?: number;
  disabled?: boolean;
  documentType?: IDocumentType;
  hasDocumentIdentification?: boolean;
  hasDropHookOptions?: boolean;
  dropHookType?: number;
  plateFormatType?: number;
  hasPlateFormat?: boolean;
}

export interface IConfigurationProcessActive {
  id: number;
  description: string;
  active: boolean;
  vehicleSteps?: string[];
}

export interface IReportState {
  configurationActive: IConfigurationActive;
  configurationProcessActive: IConfigurationProcessActive;
  locationList: ILocationData;
  visibleDrawer: boolean;
  visibleProcessDrawer: boolean;
  dropHookTypeActive: number;
  dropHookActive: boolean;
  locationActiveList: ILocationActiveData;
  isLoading: boolean;
  isLoadingTable: boolean;
  isLoadingLocationEdit: boolean;
  formViewOrEditModified: boolean;
  createActive: boolean;
  processList: IProcessData[];
  originalProcessList: IProcessData[];
  structuresList: IStructureData[];
  structuresAllList: IStructuresAllData[];
  locationByStructureIdList: IlocationByStructureId[];
  locationStructure: IStructuresAllData[];
  processActive: Array<[]>;
  structureActive: number;
  hasAttendanceActive: boolean;
  hasEntryPermissionActive: boolean;
  expirationTimeActive: number;
  checkinActive: boolean;
  documentTypeActive: IDocumentType;
  requestVehicleInboundActionActive: boolean;
  requestDockEntryActionActive: boolean;
  hasFinishOperationActionActive: boolean;
  releaseVehicleActionActive: boolean;
  vehicleArrivalConfirmActionActive: boolean;
  hasCheckinScheduleActive: boolean;
  hasReleaseWMSDocumentsActive: boolean;
  hasLocationOutOfRangeActive: boolean;
  hasRfidReadingActive: boolean;
  items?: Array<IItems>;
  totalItems: number;
  plateFormatType: number;
  itemActive: ILocation;
  filter: ILocationFilter;
  searchFilter: string;
}

export const locationData = {
  id: null,
  description: "",
};

const localState = locationData;

export const structureData = [
  {
    id: null,
    description: "",
  },
];

const structureState = structureData;

export const locationActiveData = {
  id: null,
  description: "",
};

export const configurationActiveData = {
  id: null,
  description: "-",
  configuration: false,
  descriptionName: "-",
  configurationName: "-",
  isCheckinTime: false,
  expirationTime: null,
  documentType: null,
  disabled: false,
  hasDocumentIdentification: false,
  dropHookType: null,
  plateFormatType: 0,
  hasPlateFormat: false,
};

export const configurationProcessActiveData = {
  id: null,
  description: "-",
  active: false,
  vehicleSteps: [],
};

const localActiveState = locationActiveData;

export const defaultState: IReportState = {
  locationList: localState,
  visibleDrawer: false,
  visibleProcessDrawer: false,
  locationActiveList: localActiveState,
  isLoading: false,
  isLoadingTable: false,
  isLoadingLocationEdit: false,
  formViewOrEditModified: false,
  createActive: false,
  searchFilter: "",
  processList: [],
  originalProcessList: [],
  structuresList: [],
  structuresAllList: structureState,
  locationByStructureIdList: structureState,
  locationStructure: null,
  processActive: [],
  structureActive: null,
  hasAttendanceActive: false,
  expirationTimeActive: 48,
  checkinActive: false,
  dropHookTypeActive: null,
  dropHookActive: false,
  requestVehicleInboundActionActive: false,
  documentTypeActive: 0,
  requestDockEntryActionActive: false,
  hasFinishOperationActionActive: false,
  releaseVehicleActionActive: false,
  vehicleArrivalConfirmActionActive: false,
  hasReleaseWMSDocumentsActive: false,
  hasLocationOutOfRangeActive: false,
  hasCheckinScheduleActive: false,
  hasEntryPermissionActive: false,
  hasRfidReadingActive: false,
  plateFormatType: 0,
  configurationActive: configurationActiveData,
  configurationProcessActive: configurationProcessActiveData,
  items: [],
  itemActive: null,
  totalItems: 0,
  filter: {
    orderBy: "",
    ascend: "",
    itemsByPage: 10,
    pageIndex: 1,
  },
};
